import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as componentStore from '../../../component-store'

@ngCore.Component({
  imports: [
    ds.input.text.Component,
    ds.input.code.Component,
    ngCommon.JsonPipe,
  ],
  selector: 'atn-segment-dialog-query-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.segment.Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /**
   * Updates {@link componentStore.builder.State.editingSegment} with changed query
   */
  public queryChangeHandler(query: unknown): void {
    this.store.updateEditingSegment({
      query: query as ents.core.mosaic.Page.Segment.Query,
    })
  }
}
